
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getSiteSettings"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"videoSettingsQuery"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ad_provider"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"enable_fms"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"skimlinksQuery"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"skimlinks_publisher_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skimlinks_script_url"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"article"},"name":{"kind":"Name","value":"disclaimer_article"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"video"},"name":{"kind":"Name","value":"disclaimer_video"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"gallery"},"name":{"kind":"Name","value":"disclaimer_gallery"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"episode"},"name":{"kind":"Name","value":"disclaimer_episode"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"recipe"},"name":{"kind":"Name","value":"disclaimer_recipe"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":330}};
    doc.loc.source = {"body":"query getSiteSettings {\r\n  videoSettingsQuery {\r\n    ad_provider\r\n    enable_fms\r\n  }\r\n  skimlinksQuery {\r\n    skimlinks_publisher_code\r\n    skimlinks_script_url\r\n    article: disclaimer_article\r\n    video: disclaimer_video\r\n    gallery: disclaimer_gallery\r\n    episode: disclaimer_episode\r\n    recipe: disclaimer_recipe\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["getSiteSettings"] = oneQuery(doc, "getSiteSettings");
        
